import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { CadenceType } from '~/monolith-api';

export type GetScheduleForDocumentResult = {
   prsid: number;
   title: string;
   cadence_type: CadenceType;
   grace: number;
   absolute_cadence_day: number;
   absolute_cadence_month: number;
   relative_cadence_span: number;
   userid: number;
   created_date: number;
   deleted: number;
   deleted_date: null | number;
   next_due_date: number;
   next_due_day: number;
   next_due_month: number;
   canISetDocSchedule: boolean;
};

export type GetScheduleForDocumentOptions = CommonRequestOptions & {
   doctype: string;
   docid: number;
};

export function getScheduleForDocument({
   doctype,
   docid,
   ...common
}: GetScheduleForDocumentOptions): Promise<GetScheduleForDocumentResult> {
   return makeRequest('get', `periodic_review/${doctype}/${docid}`, {
      ...common,
   });
}
